import { useTranslation } from '../../i18n/LanguageContext'
import './Download.css'

// Title Icons - Medieval style
const ScrollIcon = () => (
  <svg viewBox="0 0 32 32" width="28" height="28" style={{verticalAlign: 'middle'}}>
    <defs>
      <linearGradient id="scrollPaper" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fef9ed"/>
        <stop offset="50%" stopColor="#f5e6c8"/>
        <stop offset="100%" stopColor="#e8d5a8"/>
      </linearGradient>
      <linearGradient id="scrollWood" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#8b5a2b"/>
        <stop offset="50%" stopColor="#6b4423"/>
        <stop offset="100%" stopColor="#8b5a2b"/>
      </linearGradient>
      <radialGradient id="scrollShine" cx="50%" cy="20%" r="60%">
        <stop offset="0%" stopColor="#fffef5" stopOpacity="0.6"/>
        <stop offset="100%" stopColor="#e8d5a8" stopOpacity="0"/>
      </radialGradient>
      <filter id="scrollShadow">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.6"/>
      </filter>
    </defs>
    
    {/* Sombra */}
    <ellipse cx="16" cy="28" rx="13" ry="2" fill="#000" opacity="0.12" filter="url(#scrollShadow)"/>
    
    {/* Bastão esquerdo */}
    <rect x="2" y="4" width="3" height="24" rx="1.5" fill="url(#scrollWood)" stroke="#4a2f17" strokeWidth="0.4"/>
    <rect x="2.5" y="5" width="2" height="22" rx="1" fill="#6b4423" opacity="0.4"/>
    <circle cx="3.5" cy="5" r="1.2" fill="#8b5a2b"/>
    <circle cx="3.5" cy="27" r="1.2" fill="#6b4423"/>
    
    {/* Bastão direito */}
    <rect x="27" y="4" width="3" height="24" rx="1.5" fill="url(#scrollWood)" stroke="#4a2f17" strokeWidth="0.4"/>
    <rect x="27.5" y="5" width="2" height="22" rx="1" fill="#6b4423" opacity="0.4"/>
    <circle cx="28.5" cy="5" r="1.2" fill="#8b5a2b"/>
    <circle cx="28.5" cy="27" r="1.2" fill="#6b4423"/>
    
    {/* Pergaminho principal */}
    <path d="M5 6 Q5 4 7 4 L25 4 Q27 4 27 6 L27 26 Q27 28 25 28 L7 28 Q5 28 5 26 Z" 
          fill="url(#scrollPaper)" 
          stroke="#d4b896" 
          strokeWidth="0.5"/>
    
    {/* Brilho no papel */}
    <ellipse cx="16" cy="10" rx="8" ry="5" fill="url(#scrollShine)"/>
    
    {/* Bordas rasgadas do pergaminho */}
    <g opacity="0.2">
      <path d="M7 4 L8 4.3 L7.5 4.6 L8.2 4.9 L7.8 5.2" stroke="#c9a878" strokeWidth="0.3" fill="none"/>
      <path d="M25 4 L24 4.3 L24.5 4.6 L23.8 4.9 L24.2 5.2" stroke="#c9a878" strokeWidth="0.3" fill="none"/>
      <path d="M7 28 L8 27.7 L7.5 27.4 L8.2 27.1 L7.8 26.8" stroke="#c9a878" strokeWidth="0.3" fill="none"/>
      <path d="M25 28 L24 27.7 L24.5 27.4 L23.8 27.1 L24.2 26.8" stroke="#c9a878" strokeWidth="0.3" fill="none"/>
    </g>
    
    {/* Textura do pergaminho */}
    <g opacity="0.15" stroke="#c9a878" strokeWidth="0.15">
      <line x1="8" y1="7" x2="24" y2="7"/>
      <line x1="8" y1="10" x2="24" y2="10"/>
      <line x1="8" y1="13" x2="24" y2="13"/>
      <line x1="8" y1="16" x2="24" y2="16"/>
      <line x1="8" y1="19" x2="24" y2="19"/>
      <line x1="8" y1="22" x2="24" y2="22"/>
      <line x1="8" y1="25" x2="24" y2="25"/>
    </g>
    
    {/* Texto/escritas decorativas */}
    <g opacity="0.35" fill="#8b6914">
      <rect x="9" y="8" width="10" height="1" rx="0.5"/>
      <rect x="9" y="11" width="13" height="0.8" rx="0.4"/>
      <rect x="9" y="14" width="11" height="0.8" rx="0.4"/>
      <rect x="9" y="17" width="12" height="0.8" rx="0.4"/>
      <rect x="9" y="20" width="10" height="0.8" rx="0.4"/>
      <rect x="9" y="23" width="8" height="0.8" rx="0.4"/>
    </g>
    
    {/* Selo de cera */}
    <circle cx="22" cy="24" r="2.5" fill="#dc2626" opacity="0.9"/>
    <circle cx="22" cy="24" r="2" fill="#b91c1c"/>
    <path d="M22 22.5 L23 24 L22 25.5 L21 24 Z" fill="#991b1b" opacity="0.6"/>
    <circle cx="22" cy="24" r="0.5" fill="#7f1d1d"/>
    
    {/* Cordão do selo */}
    <path d="M22 24 Q22 26 22 28" stroke="#7f1d1d" strokeWidth="0.4" opacity="0.5"/>
  </svg>
)

const CastleIcon = () => (
  <svg viewBox="0 0 32 32" width="28" height="28" style={{verticalAlign: 'middle'}}>
    <defs>
      <linearGradient id="castleStone" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#a8b5c4"/>
        <stop offset="50%" stopColor="#6b7280"/>
        <stop offset="100%" stopColor="#3d4450"/>
      </linearGradient>
      <linearGradient id="castleRoof" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ef4444"/>
        <stop offset="50%" stopColor="#b91c1c"/>
        <stop offset="100%" stopColor="#7f1d1d"/>
      </linearGradient>
      <linearGradient id="castleDoor" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#92401e"/>
        <stop offset="50%" stopColor="#7c2d12"/>
        <stop offset="100%" stopColor="#5a1d0a"/>
      </linearGradient>
      <linearGradient id="castleFlag" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#fef08a"/>
        <stop offset="50%" stopColor="#f59e0b"/>
        <stop offset="100%" stopColor="#d97706"/>
      </linearGradient>
      <radialGradient id="castleShine" cx="30%" cy="20%" r="70%">
        <stop offset="0%" stopColor="#e5e7eb" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#1f2937" stopOpacity="0"/>
      </radialGradient>
      <filter id="castleShadow">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.4"/>
      </filter>
    </defs>
    
    {/* Sombra base */}
    <ellipse cx="16" cy="28" rx="13" ry="2" fill="#000" opacity="0.15" filter="url(#castleShadow)"/>
    
    {/* Base do castelo */}
    <rect x="2" y="27" width="28" height="1.5" fill="#4b5563" opacity="0.7"/>
    <g opacity="0.3">
      <line x1="2" y1="27.2" x2="30" y2="27.2" stroke="#1f2937" strokeWidth="0.15"/>
      <circle cx="6" cy="27.75" r="0.5" fill="#1f2937" opacity="0.5"/>
      <circle cx="12" cy="27.75" r="0.5" fill="#1f2937" opacity="0.5"/>
      <circle cx="18" cy="27.75" r="0.5" fill="#1f2937" opacity="0.5"/>
      <circle cx="24" cy="27.75" r="0.5" fill="#1f2937" opacity="0.5"/>
    </g>
    
    {/* Torre esquerda */}
    <g>
      <rect x="2" y="10" width="8" height="17" fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.5"/>
      <rect x="2" y="10" width="8" height="17" fill="url(#castleShine)"/>
      
      {/* Ameias */}
      <g fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.3">
        <rect x="2" y="10" width="2" height="2" rx="0.2"/>
        <rect x="5" y="10" width="2" height="2" rx="0.2"/>
        <rect x="8" y="10" width="2" height="2" rx="0.2"/>
      </g>
      
      {/* Textura de pedra com sombreamento */}
      <g opacity="0.25" strokeWidth="0.2">
        <line x1="2" y1="14" x2="10" y2="14" stroke="#000"/>
        <line x1="2" y1="18" x2="10" y2="18" stroke="#000"/>
        <line x1="2" y1="22" x2="10" y2="22" stroke="#000"/>
        <line x1="2" y1="26" x2="10" y2="26" stroke="#000"/>
      </g>
      
      {/* Janela com moldura dourada */}
      <rect x="4" y="16" width="3.5" height="4" rx="0.5" fill="#1e293b" stroke="#fbbf24" strokeWidth="0.4"/>
      <rect x="4.3" y="16.3" width="2.9" height="3.4" fill="#0f172a" opacity="0.6"/>
      <circle cx="5" cy="18" r="0.5" fill="#fcd34d" opacity="0.7"/>
    </g>
    
    {/* Torre direita */}
    <g>
      <rect x="22" y="10" width="8" height="17" fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.5"/>
      <rect x="22" y="10" width="8" height="17" fill="url(#castleShine)"/>
      
      {/* Ameias */}
      <g fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.3">
        <rect x="22" y="10" width="2" height="2" rx="0.2"/>
        <rect x="25" y="10" width="2" height="2" rx="0.2"/>
        <rect x="28" y="10" width="2" height="2" rx="0.2"/>
      </g>
      
      {/* Textura de pedra */}
      <g opacity="0.25" strokeWidth="0.2">
        <line x1="22" y1="14" x2="30" y2="14" stroke="#000"/>
        <line x1="22" y1="18" x2="30" y2="18" stroke="#000"/>
        <line x1="22" y1="22" x2="30" y2="22" stroke="#000"/>
        <line x1="22" y1="26" x2="30" y2="26" stroke="#000"/>
      </g>
      
      {/* Janela com moldura dourada */}
      <rect x="24" y="16" width="3.5" height="4" rx="0.5" fill="#1e293b" stroke="#fbbf24" strokeWidth="0.4"/>
      <rect x="24.3" y="16.3" width="2.9" height="3.4" fill="#0f172a" opacity="0.6"/>
      <circle cx="25" cy="18" r="0.5" fill="#fcd34d" opacity="0.7"/>
    </g>
    
    {/* Corpo central do castelo */}
    <g>
      <rect x="10" y="12" width="12" height="15" fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.5"/>
      <rect x="10" y="12" width="12" height="15" fill="url(#castleShine)"/>
      
      {/* Ameias centrais */}
      <g fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.3">
        <rect x="10" y="12" width="2" height="2" rx="0.2"/>
        <rect x="13" y="12" width="2" height="2" rx="0.2"/>
        <rect x="16" y="12" width="2" height="2" rx="0.2"/>
        <rect x="19" y="12" width="2" height="2" rx="0.2"/>
      </g>
      
      {/* Textura de pedra central */}
      <g opacity="0.25" strokeWidth="0.2">
        <line x1="10" y1="16" x2="22" y2="16" stroke="#000"/>
        <line x1="10" y1="20" x2="22" y2="20" stroke="#000"/>
        <line x1="10" y1="24" x2="22" y2="24" stroke="#000"/>
      </g>
    </g>
    
    {/* Portão principal */}
    <g>
      <path d="M13 27 Q13 20 16 20 Q19 20 19 27 Z" fill="url(#castleDoor)" stroke="#3d1a0a" strokeWidth="0.4"/>
      <rect x="13.5" y="22.5" width="5" height="4.5" rx="0.3" fill="#451a03" opacity="0.8"/>
      {/* Detalhe de madeira do portão */}
      <g opacity="0.4" strokeWidth="0.1" stroke="#92401e">
        <line x1="13" y1="22" x2="19" y2="22"/>
        <line x1="13" y1="24" x2="19" y2="24"/>
        <line x1="13" y1="26" x2="19" y2="26"/>
      </g>
      {/* Trinco dourado */}
      <circle cx="18.2" cy="24" r="0.5" fill="#fbbf24" opacity="0.9"/>
      <circle cx="18.2" cy="24" r="0.25" fill="#fcd34d"/>
    </g>
    
    {/* Torre central com topo apontado */}
    <g>
      <rect x="12" y="5" width="8" height="7" fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.5"/>
      <rect x="12" y="5" width="8" height="7" fill="url(#castleShine)"/>
      
      {/* Ameias da torre central */}
      <g fill="url(#castleStone)" stroke="#1f2937" strokeWidth="0.3">
        <rect x="12" y="5" width="1.5" height="1.5" rx="0.15"/>
        <rect x="14.5" y="5" width="1.5" height="1.5" rx="0.15"/>
        <rect x="17" y="5" width="1.5" height="1.5" rx="0.15"/>
        <rect x="19.5" y="5" width="1.5" height="1.5" rx="0.15"/>
      </g>
      
      {/* Teto cônico */}
      <path d="M12 5 L16 1 L20 5 Z" fill="url(#castleRoof)" stroke="#7f1d1d" strokeWidth="0.4"/>
      <path d="M12 5 L16 1 L20 5 Z" fill="url(#castleShine)" opacity="0.5"/>
      
      {/* Detalhe de tijolos no teto */}
      <g opacity="0.4" strokeWidth="0.15" stroke="#5a1d0a">
        <line x1="14" y1="4" x2="18" y2="4"/>
        <line x1="14.5" y1="3" x2="17.5" y2="3"/>
        <line x1="15" y1="2" x2="17" y2="2"/>
      </g>
    </g>
    
    {/* Mastro da bandeira */}
    <line x1="16" y1="1" x2="16" y2="-1" stroke="#92401e" strokeWidth="0.6" opacity="0.8"/>
    <circle cx="16" cy="0.5" r="0.5" fill="#fbbf24"/>
    
    {/* Bandeira ornamentada com padrão */}
    <g>
      <path d="M16 0 L16 5 L24 3 Z" fill="url(#castleFlag)" stroke="#d97706" strokeWidth="0.3"/>
      {/* Padrão na bandeira */}
      <g opacity="0.5">
        <line x1="17" y1="1.5" x2="22" y2="2.5" stroke="#d97706" strokeWidth="0.15"/>
        <line x1="17" y1="3" x2="22" y2="3.5" stroke="#d97706" strokeWidth="0.15"/>
      </g>
      {/* Brilho na bandeira */}
      <path d="M16 1 L16 4 L21 2.5 Z" fill="#fef3c7" opacity="0.4"/>
    </g>
  </svg>
)

// SVG Icons - All in shield medieval style
const YouTubeIcon = () => (
  <svg viewBox="0 0 40 40" width="42" height="42">
    <defs>
      <linearGradient id="ytShield" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#cc3333"/>
        <stop offset="50%" stopColor="#cc0000"/>
        <stop offset="100%" stopColor="#990000"/>
      </linearGradient>
    </defs>
    {/* Shield shape */}
    <path d="M20 2 L36 8 L36 22 C36 32 20 38 20 38 C20 38 4 32 4 22 L4 8 Z" 
      fill="url(#ytShield)" stroke="#660000" strokeWidth="1.5"/>
    {/* Inner shield */}
    <path d="M20 5 L33 10 L33 22 C33 30 20 35 20 35 C20 35 7 30 7 22 L7 10 Z" 
      fill="#cc0000"/>
    {/* Play button - detailed */}
    <path d="M15 12 L15 28 L29 20 Z" fill="white" opacity="0.95"/>
    <path d="M15 12 L15 28 L29 20 Z" fill="none" stroke="#ffcccc" strokeWidth="0.5"/>
    {/* Decorative lines */}
    <path d="M10 14 L10 18" stroke="#ff6666" strokeWidth="1" opacity="0.5"/>
    <path d="M30 14 L30 18" stroke="#ff6666" strokeWidth="1" opacity="0.5"/>
  </svg>
)

const TutorialIcon = () => (
  <svg viewBox="0 0 40 40" width="42" height="42">
    <defs>
      <linearGradient id="tutShield" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#d4a574"/>
        <stop offset="50%" stopColor="#c7944d"/>
        <stop offset="100%" stopColor="#b8803d"/>
      </linearGradient>
      <linearGradient id="spineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#8b6f47"/>
        <stop offset="50%" stopColor="#6b5839"/>
        <stop offset="100%" stopColor="#5a4a2a"/>
      </linearGradient>
      <linearGradient id="parchment" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fffef5"/>
        <stop offset="100%" stopColor="#f0e8d8"/>
      </linearGradient>
      <filter id="pageShadow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.4"/>
      </filter>
      <pattern id="parchmentTexture" x="0" y="0" width="2" height="2" patternUnits="userSpaceOnUse">
        <rect width="2" height="2" fill="#fffef5"/>
        <circle cx="0.5" cy="0.5" r="0.3" fill="#e8dcc8" opacity="0.4"/>
      </pattern>
    </defs>
    
    {/* Shield shape */}
    <path d="M20 2 L36 8 L36 22 C36 32 20 38 20 38 C20 38 4 32 4 22 L4 8 Z" 
      fill="url(#tutShield)" stroke="#5a4a2a" strokeWidth="2"/>
    
    {/* Gold decorative inner border */}
    <path d="M20 3.5 L35 9 L35 22 C35 31 20 37 20 37 C20 37 5 31 5 22 L5 9 Z" 
      fill="none" stroke="#e8c75c" strokeWidth="0.7" opacity="0.6"/>
    
    {/* Inner shield */}
    <path d="M20 5 L33 10 L33 22 C33 30 20 35 20 35 C20 35 7 30 7 22 L7 10 Z" 
      fill="#c7944d"/>
    
    {/* Shield corner ornaments */}
    <g opacity="0.7">
      <circle cx="7" cy="11" r="1.2" fill="#e8c75c"/>
      <path d="M7 9.5 L7 12.5 M5.5 11 L8.5 11" stroke="#8b6f47" strokeWidth="0.8" strokeLinecap="round"/>
      
      <circle cx="33" cy="11" r="1.2" fill="#e8c75c"/>
      <path d="M33 9.5 L33 12.5 M31.5 11 L34.5 11" stroke="#8b6f47" strokeWidth="0.8" strokeLinecap="round"/>
    </g>
    
    {/* Book pages - left page shadow */}
    <rect x="11" y="13.5" width="7.5" height="11" rx="0.6" fill="#e8dcc8" opacity="0.4" filter="url(#pageShadow)"/>
    
    {/* Main book shape with texture */}
    <rect x="11" y="13" width="16" height="12" rx="0.8" fill="url(#parchmentTexture)" stroke="#6b5839" strokeWidth="1.2"/>
    <rect x="11" y="13" width="16" height="12" rx="0.8" fill="url(#parchment)" opacity="0.85"/>
    
    {/* Book spine - ornamental with shadow */}
    <rect x="11" y="13" width="2.4" height="12" fill="url(#spineGrad)" stroke="#4a3a1a" strokeWidth="0.5"/>
    <line x1="12" y1="14.5" x2="12" y2="24" stroke="#9d8a5d" strokeWidth="0.5" opacity="0.6"/>
    
    {/* Decorative binding lines on spine */}
    <g opacity="0.5">
      <line x1="11" y1="16" x2="13.4" y2="16" stroke="#c9a227" strokeWidth="0.4"/>
      <line x1="11" y1="20" x2="13.4" y2="20" stroke="#c9a227" strokeWidth="0.4"/>
    </g>
    
    {/* Decorative corners on book */}
    <circle cx="11.5" cy="13.5" r="0.7" fill="#d4a574" opacity="0.7"/>
    <circle cx="27" cy="13.5" r="0.7" fill="#d4a574" opacity="0.7"/>
    <circle cx="11.5" cy="24.7" r="0.7" fill="#d4a574" opacity="0.5"/>
    <circle cx="27" cy="24.7" r="0.7" fill="#d4a574" opacity="0.5"/>
    
    {/* Medieval decorative corner flourishes */}
    <g stroke="#c9a227" strokeWidth="0.4" fill="none" opacity="0.6">
      <path d="M11 14 L9.5 13 L11 12"/>
      <path d="M27.5 14 L29 13 L27.5 12"/>
    </g>
    
    {/* Ornamental text lines - main title with flourish */}
    <path d="M15 15 Q20 14.5 25.5 15" stroke="#5a3a20" strokeWidth="1" fill="none" opacity="0.9" strokeLinecap="round"/>
    
    {/* Content lines - varying style */}
    <line x1="15" y1="16.8" x2="24.5" y2="16.8" stroke="#6b4a2e" strokeWidth="0.7" opacity="0.8"/>
    <line x1="15" y1="18.2" x2="26" y2="18.2" stroke="#6b4a2e" strokeWidth="0.7" opacity="0.8"/>
    <line x1="15" y1="19.6" x2="25" y2="19.6" stroke="#6b4a2e" strokeWidth="0.7" opacity="0.7"/>
    <line x1="15" y1="21" x2="23" y2="21" stroke="#6b4a2e" strokeWidth="0.7" opacity="0.7"/>
    
    {/* Decorative ending flourish */}
    <path d="M15 22.5 Q18 22 21 22.5" stroke="#6b4a2e" strokeWidth="0.6" fill="none" opacity="0.7" strokeLinecap="round"/>
    
    {/* Medieval bookmark ribbon with depth */}
    <defs>
      <linearGradient id="ribbonGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#d14c3c"/>
        <stop offset="50%" stopColor="#c73e1d"/>
        <stop offset="100%" stopColor="#d14c3c"/>
      </linearGradient>
    </defs>
    <path d="M24 13 L24 19 L26 17.2 L28 19 L28 13 Z" fill="url(#ribbonGrad)" opacity="0.98"/>
    <path d="M24 13 L24 19 L26 17.2 L28 19 L28 13 Z" stroke="#8b2810" strokeWidth="0.6" fill="none"/>
    
    {/* Ribbon details - fold lines */}
    <line x1="24.5" y1="14" x2="24.5" y2="18" stroke="rgba(255,255,255,0.2)" strokeWidth="0.3"/>
    <line x1="27.5" y1="14" x2="27.5" y2="18" stroke="rgba(255,255,255,0.2)" strokeWidth="0.3"/>
    
    {/* Ribbon frayed edges */}
    <g opacity="0.7">
      <path d="M24 19 L23 19.8 L25 19 Z" fill="#a83515"/>
      <path d="M28 19 L29 19.8 L27 19 Z" fill="#a83515"/>
    </g>
    
    {/* Small decorative element - quill/feather hint */}
    <g opacity="0.5">
      <circle cx="29.5" cy="15" r="0.5" fill="#d4a574"/>
    </g>
  </svg>
)

// Detailed medieval-style social icons
const FacebookIcon = () => (
  <svg viewBox="0 0 40 40" width="42" height="42">
    <defs>
      <linearGradient id="fbShield" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#5a7fd4"/>
        <stop offset="50%" stopColor="#4267B2"/>
        <stop offset="100%" stopColor="#2d4373"/>
      </linearGradient>
    </defs>
    {/* Shield shape */}
    <path d="M20 2 L36 8 L36 22 C36 32 20 38 20 38 C20 38 4 32 4 22 L4 8 Z" 
      fill="url(#fbShield)" stroke="#1e3a5f" strokeWidth="1.5"/>
    {/* Inner shield */}
    <path d="M20 5 L33 10 L33 22 C33 30 20 35 20 35 C20 35 7 30 7 22 L7 10 Z" 
      fill="#4267B2"/>
    {/* F letter - detailed */}
    <path d="M22 11 L22 15 L26 15 L26 17 L22 17 L22 29 L18 29 L18 17 L15 17 L15 15 L18 15 L18 13 C18 11 19.5 10 22 10 L26 10 L26 12 L23 12 C22 12 22 12.5 22 13 Z" 
      fill="white" stroke="#e8e8e8" strokeWidth="0.3"/>
    {/* Decorative corners */}
    <circle cx="10" cy="14" r="1" fill="#6a8fd8" opacity="0.6"/>
    <circle cx="30" cy="14" r="1" fill="#6a8fd8" opacity="0.6"/>
  </svg>
)

const WhatsAppIcon = () => (
  <svg viewBox="0 0 40 40" width="42" height="42">
    <defs>
      <linearGradient id="waShield" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#34eb7a"/>
        <stop offset="50%" stopColor="#25d366"/>
        <stop offset="100%" stopColor="#128c7e"/>
      </linearGradient>
    </defs>
    {/* Shield shape */}
    <path d="M20 2 L36 8 L36 22 C36 32 20 38 20 38 C20 38 4 32 4 22 L4 8 Z" 
      fill="url(#waShield)" stroke="#0d5c4a" strokeWidth="1.5"/>
    {/* Inner shield */}
    <path d="M20 5 L33 10 L33 22 C33 30 20 35 20 35 C20 35 7 30 7 22 L7 10 Z" 
      fill="#25d366"/>
    {/* Phone bubble - detailed */}
    <path d="M20 10 C14.5 10 10 14 10 18.5 C10 20.5 10.7 22.3 12 23.8 L11 28 L15.5 27 C17 27.7 18.5 28 20 28 C25.5 28 30 24 30 19.5 C30 15 25.5 10 20 10 Z" 
      fill="white" stroke="#e0e0e0" strokeWidth="0.3"/>
    {/* Phone handset */}
    <path d="M15 16 C15 16 15.5 15 16.5 15 C17.5 15 18 16 18 16 L18.5 18 C18.5 18 18 18.5 17.5 18.5 C17 18.5 16.5 19 17 20 C17.5 21 19 23 20 23.5 C21 24 21.5 23.5 22 23 C22.5 22.5 23 22.5 23 22.5 L25 23.5 C25 23.5 25.5 24 25 25 C24.5 26 23.5 26 22.5 26 C21.5 26 19 25 17.5 23.5 C16 22 14.5 19.5 14.5 18 C14.5 16.5 15 16 15 16 Z" 
      fill="#25d366"/>
    {/* Decorative */}
    <circle cx="10" cy="14" r="1" fill="#4aea8a" opacity="0.6"/>
    <circle cx="30" cy="14" r="1" fill="#4aea8a" opacity="0.6"/>
  </svg>
)

const DiscordIcon = () => (
  <svg viewBox="0 0 40 40" width="42" height="42">
    <defs>
      <linearGradient id="dcShield" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#9aabeb"/>
        <stop offset="50%" stopColor="#7289da"/>
        <stop offset="100%" stopColor="#5865f2"/>
      </linearGradient>
    </defs>
    {/* Shield shape */}
    <path d="M20 2 L36 8 L36 22 C36 32 20 38 20 38 C20 38 4 32 4 22 L4 8 Z" 
      fill="url(#dcShield)" stroke="#4752c4" strokeWidth="1.5"/>
    {/* Inner shield */}
    <path d="M20 5 L33 10 L33 22 C33 30 20 35 20 35 C20 35 7 30 7 22 L7 10 Z" 
      fill="#5865f2"/>
    {/* Discord controller shape - detailed */}
    <path d="M11 14 C11 14 13 12 20 12 C27 12 29 14 29 14 C29 14 31 19 31 23 C31 23 29 26 20 26 C11 26 9 23 9 23 C9 23 11 19 11 14 Z" 
      fill="white" stroke="#e0e0e0" strokeWidth="0.3"/>
    {/* Left eye */}
    <ellipse cx="15" cy="19" rx="2.5" ry="3.5" fill="#5865f2"/>
    <ellipse cx="14.5" cy="18" rx="0.8" ry="1" fill="white" opacity="0.4"/>
    {/* Right eye */}
    <ellipse cx="25" cy="19" rx="2.5" ry="3.5" fill="#5865f2"/>
    <ellipse cx="24.5" cy="18" rx="0.8" ry="1" fill="white" opacity="0.4"/>
    {/* Decorative */}
    <circle cx="10" cy="13" r="1" fill="#a0b0f0" opacity="0.6"/>
    <circle cx="30" cy="13" r="1" fill="#a0b0f0" opacity="0.6"/>
  </svg>
)

const Download = () => {
  const { t } = useTranslation()
  const resources = [
    {
      icon: <YouTubeIcon />,
      label: 'YouTube',
      href: 'https://www.youtube.com/@unitybot9708/featured',
    },
    {
      icon: <TutorialIcon />,
      label: t('download.tutorial'),
      href: 'https://unitybot.weebly.com/tutoriais.html',
    }
  ]

  const socialLinks = [
    {
      icon: <FacebookIcon />,
      label: t('download.facebook'),
      href: 'https://www.facebook.com/TibiaMEUnityBOT',
      color: 'blue'
    },
    {
      icon: <WhatsAppIcon />,
      label: t('download.whatsApp'),
      href: 'https://chat.whatsapp.com/HnGsjkXjzWS2jZs81Cj9C8',
      color: 'green'
    },
    {
      icon: <DiscordIcon />,
      label: t('download.discord'),
      href: 'https://discord.gg/bSCXzFuN4G',
      color: 'purple'
    }
  ]

  return (
    <section className="download" id="download">
      <div className="download__container">
        <div className="download__content">
          <div className="download__resources">
            <h3 className="download__title">
              <span className="download__title-icon"><ScrollIcon /></span>
              {t('download.guidesTitle')}
            </h3>
            <div className="download__resources-links">
              {resources.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download__resource-link"
                >
                  <span className="download__resource-icon">{item.icon}</span>
                  <span className="download__resource-label">{item.label}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="download__divider">
            <span className="download__divider-icon">⚜</span>
          </div>

          {/* Social Links */}
          <div className="download__social">
            <h3 className="download__title">
              <span className="download__title-icon"><CastleIcon /></span>
              {t('download.communityTitle')}
            </h3>
            <div className="download__social-links">
              {socialLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`download__social-btn download__social-btn--${item.color}`}
                  title={item.label}
                >
                  <span className="download__social-icon">{item.icon}</span>
                  <span className="download__social-label">{item.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Download
